/**
 * Gera e baixa uma planilha .xlsx a partir dos dados já carregados na tela —
 * sem chamada nova à API. O que a tela mostra é exatamente o que sai na
 * planilha, então a mesma filtragem por papel que já protege a tela (o
 * financeiro nunca recebe nome de adolescente, por exemplo) vale aqui de
 * graça: não há nada para vazar que a tela já não tivesse.
 *
 * Import dinâmico: a `xlsx` sozinha pesa mais que o resto do app, e quem
 * preenche a ficha pública nunca usa exportação nenhuma — carregar isso no
 * bundle de todo mundo só para o admin clicar um botão às vezes é desperdício.
 */
export async function exportarXlsx(nomeArquivo: string, linhas: Record<string, unknown>[]) {
  const XLSX = await import('xlsx');
  const planilha = XLSX.utils.json_to_sheet(linhas);
  const livro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(livro, planilha, 'Dados');
  XLSX.writeFile(livro, `${nomeArquivo}.xlsx`);
}
